/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Project_DescInputs */

const en_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save project`)
};

const fr_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le projet`)
};

const de_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt speichern`)
};

const it_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva progetto`)
};

const ru_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить проект`)
};

const es_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto`)
};

const zh_cn2_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目`)
};

const ja_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを保存`)
};

const hi_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करें`)
};

const pt_pt2_save_project_desc = /** @type {(inputs: Save_Project_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar projeto`)
};

/**
* | output |
* | --- |
* | "Save project" |
*
* @param {Save_Project_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_project_desc = /** @type {((inputs?: Save_Project_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Project_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_project_desc(inputs)
	if (locale === "de") return de_save_project_desc(inputs)
	if (locale === "it") return it_save_project_desc(inputs)
	if (locale === "ru") return ru_save_project_desc(inputs)
	if (locale === "es") return es_save_project_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_save_project_desc(inputs)
	if (locale === "ja") return ja_save_project_desc(inputs)
	if (locale === "hi") return hi_save_project_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_save_project_desc(inputs)
	return en_save_project_desc(inputs)
});